export const ClosedStatusEnum = {
  CLOSED: 'Y',
  OPEN: 'N',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ClosedStatusEnum.js